import React from 'react';
import { Check } from 'lucide-react';
import { useLanguage } from '../../../language/hooks/useLanguageHook';
import { comparisonRows } from '../../data/landingPageData'; // Import comparison row keys

const ComparisonSection = () => {
  const { t } = useLanguage();

  return (
    <div className="relative z-10 bg-white py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16 scroll-fade-in">
          <h2 className="text-4xl font-bold mb-4">
            {t("public.landing.comparison.title")}
          </h2>
          <p className="text-xl text-gray-600">
            {t("public.landing.comparison.subtitle")}
          </p>
        </div>

        <div className="overflow-hidden rounded-xl border border-gray-200 shadow-lg scroll-slide-in">
          {/* Table Header */}
          <div className="grid grid-cols-3 bg-gray-50">
            <div className="p-6 border-r border-gray-200">
              <div className="text-lg font-semibold text-gray-900">
                {t("public.landing.comparison.table.headers.features")}
              </div>
            </div>
            <div className="p-6 border-r border-gray-200 bg-blue-50">
              <div className="text-lg font-semibold text-blue-600">
                {t("public.landing.comparison.table.headers.feedbacked")}
              </div>
            </div>
            <div className="p-6">
              <div className="text-lg font-semibold text-gray-500">
                {t("public.landing.comparison.table.headers.traditional")}
              </div>
            </div>
          </div>

          {/* Table Rows */}
          {comparisonRows.map((rowKey, index) => (
            <div
              key={rowKey}
              className={`grid grid-cols-3 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}
            >
              {/* Feature Column */}
              <div className="p-6 border-r border-gray-200 font-medium">
                {t(`public.landing.comparison.table.rows.${rowKey}.feature`)}
              </div>
              {/* FeedBacked Column */}
              <div className={`p-6 border-r border-gray-200 bg-blue-50`}>
                <div className="flex items-center">
                  <Check className="h-5 w-5 text-green-500 mr-2" />
                  {t(`public.landing.comparison.table.rows.${rowKey}.feedbacked`)}
                </div>
              </div>
              {/* Traditional Column */}
              <div className="p-6 text-gray-500">
                {t(`public.landing.comparison.table.rows.${rowKey}.traditional`)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ComparisonSection; 